<!-- TODO NEED OPTIMIZATION; MY-PROFILE AND PROFILE HAS SIMILAR CODE -->
<template>
    <section class="my-profile">

      <div class="title-container">
        <h1 class="title">
          {{ userName }}
          <b-badge v-if="isUserProfile" class="user-profile-badge">
            User profile
          </b-badge>
          <div
            v-if="isDataLoading" class="spinner-border spinner-theme_default"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </h1>
        <div class="title-container__controls">
          <b-button
            v-if="!isUserProfile"
            class="button title-container__controls-item"
            variant="outline"
            @click="setVisiblePasswordModal(true)"
          >
            Change password
          </b-button>
          <b-button
            class="button"
            variant="primary"
            :disabled="isDataLoading"
            @click="setVisibleEditModal(true)"
          >
            Edit Profile
          </b-button>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div
            class="table__theme-default table__none-hover"
            v-if="table.items.length"
          >
            <div class="table-container pb-0">
              <b-table
                primary-key="id"
                :fields="tableFields"
                :items="table.items"
                style="margin-bottom: 0;"
                fixed
              >
                <template v-slot:cell(avatar)="data">
                  <b-img
                    v-if="data.item.avatar"
                    :src="data.item.avatar"
                    rounded="circle"
                    alt="Circle image"
                    class="user-profile-avatar"
                  />
                  <b-img
                    v-else
                    v-bind="mainProps"
                    rounded="circle"
                    alt="Circle image"
                    class="user-profile-avatar"
                  />
                </template>
                <template v-slot:cell(show_on_widget)="data" v-if="$can('update_all-users')">
                  <div>
                    <b-button
                      variant="secondary"
                      class="button btn-icon"
                      title="Active"
                    >
                      <b-form-checkbox
                        size="sm"
                        switch
                        v-model="data.item.show_on_widget"
                        disabled
                        class="switch"
                        @click.native="switchShowOnProfilesWidget(data.item)"
                      />
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(is_contact_person)="data" v-if="$can('update_all-users') && !isUserProfile">
                  <div>
                    <b-button
                      variant="secondary"
                      class="button btn-icon"
                      title="Active"
                    >
                      <b-form-checkbox
                        size="sm"
                        switch
                        v-model="data.item.is_contact_person"
                        disabled
                        class="switch"
                        @click.native="switchIsContactPerson(data.item)"
                      />
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(convert_into_user)="data" v-if="$can('update_all-users') && isUserProfile">
                  <div>
                    <b-button
                      variant="secondary"
                      class="button"
                      @click.prevent="editProfile.showConvertIntoUserModal = true"
                    >
                      Convert
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(actions)="data" v-if="$can('update_all-users') && !isUserProfile">
                  <div class="d-flex">
                    <b-button
                      variant="secondary"
                      class="button btn-icon"
                      title="Active"
                    >
                      <b-form-checkbox
                        size="sm"
                        switch
                        v-model="data.item.userStatus"
                        disabled
                        class="switch"
                        @click.native="changeUserStatus(!data.item.userStatus, data.item)"
                      />
                    </b-button>
                    <b-button
                      variant="secondary"
                      class="button btn-icon ml-4"
                      title="No reporting"
                    >
                      <b-form-checkbox
                        size="sm"
                        switch
                        v-model="data.item.no_reporting"
                        disabled
                        class="switch"
                        @click.native="switchNoReporting(data.item, data.index)"
                      />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <user-skills
            v-if="access && $can('read_all-skills')"
          />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <div class="editor-container">
            <TextEditor :in-modal="false" />
          </div>
        </div>
      </div>

      <ModalRestoreUser
        v-model="modalRestoreUser.show"
        :loading="isDataLoading"
        @submit="restoreUser"
      />
      <ModalDeleteUser
        v-model="modalDeletedUser.show"
        :loading="isDataLoading"
        @submit="deletedUser"
      />
      <b-modal
        v-model="changePassword.showModal"
        size="md"
        :style="{ zIndex: 200 }"
        no-close-on-backdrop
      >
        <template  v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Change Password</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>
        <FormGenerator
          :data="changePassword.form"
          :showFormControls="false"
          @submit="updatePassword"
          ref="changePasswordForm"
        >
        </FormGenerator>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="submitPasswordFormModal"
          >
            Save changes
          </b-button>
        </template>
      </b-modal>
      <b-modal
        v-model="editProfile.showModal"
        size="md"
        :style="{ zIndex: 200 }"
        no-close-on-backdrop
      >
        <template  v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Edit Profile</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>

        <div class="mb-3 text-center">
          <b-img
            v-if="userAvatar"
            :src="userAvatar"
            :width="128"
            rounded="circle"
            alt="Avatar image"
          />
          <b-img
            v-else
            v-bind="mainProps"
            rounded="circle"
            alt="Circle image"
          />

          <input
            type="file"
            ref="avatarFile"
            accept="image/*"
            hidden
            @change="handleAvatarFile"
          >

          <b-button
            class="button mt-3 mx-auto"
            variant="primary"
            @click="$refs.avatarFile.click()"
          >
            Change avatar
          </b-button>
        </div>

        <FormGenerator
          :data="editProfile.form"
          :showFormControls="false"
          @input="inputFormField"
          @submit="update"
          ref="form"
        >
          <template v-if="isUserProfile" v-slot:skills="{ data }">
            <b-form-group>
              <label>{{ data.label }}</label>
              <UserProfileSkills v-model="data.value" />
            </b-form-group>
          </template>
        </FormGenerator>

        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="submitModal"
          >
            Save changes
          </b-button>
        </template>
      </b-modal>

      <b-modal
        v-model="editProfile.showAvatarCropModal"
        @hide="resetAvatarInputAfterModalClose"
        size="md"
        no-close-on-backdrop
      >
        <template  v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Crop Avatar</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>
        <cropper
          ref="avatarCropper"
          :src="editProfile.avatarFile"
          :stencilProps="{
            aspectRatio: 1/1
          }"
        />
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="uploadCroppedAvatar"
          >
            Save
          </b-button>
        </template>
      </b-modal>

      <ModalConvertIntoUser
        v-model="editProfile.showConvertIntoUserModal"
        :user-id="userId"
      />
    </section>
</template>

<script>
import UserSkills from './UserSkills'
import ModalRestoreUser from '@components/modals/ModalRestoreUser'
import ModalDeleteUser from '@components/modals/ModalDeleteUser'
import ModalConvertIntoUser from '@components/modals/ModalConvertIntoUser'
import FormGenerator from '@components/FormGenerator'
import TextEditor from '@components/TextEditor.vue'
import { mapGetters } from 'vuex'
import { Cropper } from 'vue-advanced-cropper'
import UserMixin from '@mixins/UserMixin'
import UserProfileSkills from '@components/UserProfileSkills'

export default {
  name: 'Profile',
  mixins: [UserMixin],
  components: {
    UserSkills,
    UserProfileSkills,
    ModalRestoreUser,
    ModalDeleteUser,
    ModalConvertIntoUser,
    FormGenerator,
    TextEditor,
    Cropper
  },
  computed: {
    ...mapGetters({
      getAllPartners: 'partners/getAllPartners'
    }),

    tableFields () {
      const fields = [
        {
          key: 'avatar',
          label: 'Avatar',
          class: 'column-avatar',
          visible: true
        },
        {
          key: 'name',
          label: 'Name',
          class: 'col-1',
          visible: true
        },
        {
          key: 'position',
          label: 'Position',
          class: 'col-1',
          visible: true
        },
        {
          key: 'payment_type',
          label: 'Payment type',
          class: 'col-1 payment-type',
          visible: true
        },
        {
          key: 'employment_type_full_label',
          label: 'Employment type',
          visible: true
        },
        {
          key: 'availability',
          label: 'Availability',
          visible: true
        },
        {
          key: 'years_of_experience',
          label: 'Years Of Expirience',
          visible: true
        },
        {
          key: 'seniority_lvl',
          label: 'Seniority Level',
          visible: true
        },
        {
          key: 'english_lvl',
          label: 'English Level',
          visible: true
        },
        {
          key: 'show_on_widget',
          label: 'Show on profiles widget',
          visible: true
        },
        {
          key: 'is_contact_person',
          label: 'Contact person',
          visible: !this.isUserProfile
        },
        {
          key: 'convert_into_user',
          label: 'Convert into user',
          visible: this.isUserProfile
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'col-1 text-center',
          visible: !this.isUserProfile
        }
      ]

      return fields.filter(f => f.visible)
    }
  },
  data () {
    return {
      access: true,
      userId: null,
      userType: null,
      userName: '',
      userAvatar: '',
      isUserProfile: false,
      mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
      readonly: true,
      table: {
        items: []
      },
      modalRestoreUser: {
        show: false,
        user: null
      },
      modalDeletedUser: {
        show: false,
        user: null
      },
      changePassword: {
        showModal: false,
        form: {
          'password': {
            type: 'input',
            name: 'password',
            label: 'Password',
            placeholder: 'password',
            typeInput: 'password',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          }
        }
      }
    }
  },
  comments: {
    UserSkills
  },
  methods: {
    inputFormField (fields) {
      if (fields.employment_type.value.id === 'partner') {
        fields.partner.hidden = false
      } else {
        fields.partner.hidden = true
      }
    },
    updatePassword (data) {
      const formData = {
        ...this.editProfile.form,
        ...data
      }

      this.setVisiblePasswordModal(false)
      this.update(formData)
    },
    submitPasswordFormModal () {
      this.$refs.changePasswordForm.submit()
    },
    submitModal () {
      this.$refs.form.submit()
    },
    setVisiblePasswordModal (status) {
      this.changePassword.showModal = status
    },
    setPartnersList () {
      this._toggleDataPageLoading(async () => {
        this.$api.partners.getAllPartners()
          .then(() => {
            this.editProfile.form.partner.options = this.getAllPartners
          })
      })
    },
    changeUserStatus (data, user) {
      data ? this.showModalRestoreUser(user) : this.showModalDeletedUser(user)
    },
    deletedUser (data) {
      // eslint-disable-next-line camelcase
      const date_exit = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users.deleteUser(this.modalDeletedUser.user.id, { date_exit })
          .then(response => {
            this.modalDeletedUser.user.deleted_at = response.deleted_at
            this.modalDeletedUser.user.exit_at = response.exit_at
            this.setTable(response)
          })
          .catch(err => {
            console.log(err)
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideModalDeletedUser()
          })
      })
    },
    showModalRestoreUser (user) {
      this.modalRestoreUser.show = true
      this.modalRestoreUser.user = user
    },
    hideRestoreUser () {
      this.modalRestoreUser.show = false
      this.modalRestoreUser.user = null
    },
    showModalDeletedUser (user) {
      this.modalDeletedUser.show = true
      this.modalDeletedUser.user = user
    },
    hideModalDeletedUser () {
      this.modalDeletedUser.show = false
      this.modalDeletedUser.user = null
    },
    setTable (res) {
      const data = { ...res }
      data.userStatus = data.deleted_at === null && data.exit_at === null && data.status === 'approved'
      data.no_reporting = !!data.no_reporting
      data.employment_type_full_label = data.employment_type.label
        ? data.employment_type.label + (data.partner && data.employment_type.type === 'partner' ? ` (${data.partner.company_name})` : '')
        : data.employment_type.name
      data.availability = data.availability && data.availability.name ? data.availability.name : ''
      data.seniority_lvl = data.seniority_lvl && data.seniority_lvl.name ? data.seniority_lvl.name : ''
      data.english_lvl = data.english_lvl && data.english_lvl.name ? data.english_lvl.name : ''
      this.table.items = [data]
    },
    restoreUser (data) {
      // eslint-disable-next-line camelcase
      const date_start = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users.restoreUser(this.modalRestoreUser.user.id, { date_start })
          .then((res) => {
            this.modalRestoreUser.user.deleted_at = res.deleted_at
            this.modalRestoreUser.user.exit_at = res.exit_at
            this.setTable(res)
          }).catch(err => {
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideRestoreUser()
          })
      })
    },
    switchNoReporting (user, index) {
      const invertedNoReporting = user.no_reporting ? 0 : 1
      this.axios.put(
        `/api/switch-no-reporting/${user.id}/${invertedNoReporting}`,
        {},
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.$snotify.success('No reporting ' + (response.data.no_reporting ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
        }
        this.setTable(response.data)
      }).catch(err => {
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    switchShowOnProfilesWidget (user) {
      const isShow = !user.show_on_widget || false

      this.axios.put(
        `/api/users/${user.id}/show-on-profiles-widget`,
        {
          userType: this.userType,
          showOnWidgetStatus: isShow ? 1 : 0
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          user.show_on_widget = isShow
          this.editProfile.form.show_on_widget.value = isShow
          this.$snotify.success('Show on Profiles Widget ' + (isShow ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
        }
      }).catch(err => {
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    switchIsContactPerson (user) {
      const isContactPerson = !user.is_contact_person || false
      this.axios.put(
        `/api/users/${user.id}/contact-person`,
        {
          isContactPerson: isContactPerson ? 1 : 0
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          user.is_contact_person = isContactPerson
          this.editProfile.form.is_contact_person.value = isContactPerson
          this.$snotify.success('Contact Person ' + (isContactPerson ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
        }
      }).catch(err => {
        console.log('err', err)
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    async update (data) {
      this.isDataLoading = true
      try {
        const isUpdatesUser = !this.isUserProfile
        const response = isUpdatesUser ? await this.updateUser(data) : await this.updateProfile(data)
        if (response.status === 200) {
          this.$snotify.success('Profile successfully updated', 'Success', this.$store.state.snotify)
        }
        data = response.data
        data.show_on_widget = data.show_on_widget === 1 || data.show_on_widget === true
        data.is_contact_person = data.is_contact_person === 1 || data.is_contact_person === true
        this.userName = data.name
        this.userAvatar = data.avatar
        this.userPosition = data.position
        this.setTable(data)
        isUpdatesUser ? this.fillEditUserForm(data) : this.fillEditUserProfileForm(data)
      } catch (err) {
        let errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      } finally {
        this.isDataLoading = false
      }
    },

    uploadCroppedAvatar () {
      const { canvas } = this.$refs.avatarCropper.getResult()

      if (canvas) {
        const form = new FormData()
        canvas.toBlob(blob => {
          form.append('file', blob)
          const requestUrl = this.isUserProfile
            ? `/api/users/profiles/${this.userId}/update-avatar`
            : `/api/users/${this.userId}/update-avatar`
          this.isDataLoading = true
          this.axios.post(
            requestUrl,
            form,
            {
              headers: {
                Authorization: 'Bearer' + localStorage.getItem('access_token')
              }
            }).then(response => {
            if (response.status === 200) {
              this.$snotify.success('Profile successfully updated', 'Success', this.$store.state.snotify)
            }
            this.userAvatar = response.data.avatar
          }).catch(err => {
            let errors = Object.values(err.response.data.errors)
            for (let i = 0; i < errors.length; i++) {
              this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
            }
          }).finally(() => {
            this.isDataLoading = false
            this.editProfile.showAvatarCropModal = false
          })
        }, 'image/jpeg')
      }
    },

    async getUser () {
      this.isDataLoading = true
      this.setPartnersList()
      this.userId = this.$route.params.id
      this.userType = this.$route.params.type
      this.isUserProfile = this.userType === 'user-profile'

      try {
        const response = this.isUserProfile ? await this.fetchUserProfile(this.userId) : await this.fetchUser(this.userId)
        const data = response.data
        data.show_on_widget = data.show_on_widget === 1 || data.show_on_widget === true
        data.is_contact_person = data.is_contact_person === 1 || data.is_contact_person === true
        this.readonly = false
        this.userName = data.name
        this.userAvatar = data.avatar

        this.setTable(data)
        this.isUserProfile ? this.fillEditUserProfileForm(data) : this.fillEditUserForm(data)
      } catch (err) {
        console.log(err)
      } finally {
        this.isDataLoading = false
      }
    }
  },
  mounted () {
    this.getUser()
  }
}
</script>

<style>
  .payment-type:first-letter,
  .payment-type .multiselect__single:first-letter {
    text-transform: uppercase;
  }
  .editor-container {
    background-color: #fff;
    border-radius: 10px;
    padding: 15px;
  }
</style>

<style scoped>
.user-profile-badge {
  font-size: 14px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
